export const POST_BLOB = "POST_BLOB";

export function postBlob(formData) {
  return {
    type: POST_BLOB,
    request: {
      op: "post",
      path: "blob",
      data: formData
    }
  }
}
